import { ReactNode, useContext } from 'react'
import { useHistory } from 'react-router'
import styled from 'styled-components'
import { CreationToolsContext } from '../manager'
import CreationToolOutputType from '../types/output-type'
import { BackArrowIcon } from './icons'

const Container = styled.div`
    align-items: center;
    display: flex;
    font-size: 17px;
    font-weight: bold;
    height: 36px;
    margin-bottom: 20px;
    width: 100%;
`

const BackButton = styled.div`
    align-items: center;
    cursor: pointer;
    display: flex;
    margin-right: auto;

    span {
        padding: 0 8px;
    }
`

type Props = {
    children?: ReactNode
}

const CreationToolNavigation = ({ children }: Props) => {
    const { outputType, sources } = useContext(CreationToolsContext)
    const history = useHistory()

    const onBackClick = () => {
        // If source is animated, and output will be a sticker, go back to home cause we are skipping going back to trimer
        if (outputType === CreationToolOutputType.Sticker && sources[0].isAnimated) {
            window.location.href = '/create/gifmaker'
        } else {
            history.goBack()
        }
    }

    return (
        <Container>
            <BackButton onClick={onBackClick}>
                <BackArrowIcon />
                <span>Back</span>
            </BackButton>
            {children}
        </Container>
    )
}

export default CreationToolNavigation
